module.exports = __webpack_public_path__ + "img/fw_workflow_3.d0fb0094.png";